'use strict'
import $ from 'jquery';

export class WysiwygSlider {
  constructor ($elm) {
    this.$elm = $elm;
    this.rows;
    this.slidingNum = 0;
    this.sliderWrapper = this.$elm.find('.js_wyswiwygSlider-rowWrapper');
    this.sliderContainer = this.$elm.find('.js_wyswiwygSlider-rowContainer');
    this.baseWidth = this.sliderWrapper.width()

    this.inactiveClass = "js_inactive inactive";
    this.slidingType = "carousel"; // <ENUM> carousel || transition || ""
    this.rowsHeight = [];
  }


  init () {
    this.getRows();
    this.setPagination();
    this.bindEvents();

    this.sliderWrapper.find('> .wysiwyg-insert-content').addClass('hidden');
    this.sliderContainer.html(`<div class="slideItem js_activeSlideItem">${this.rows.eq(this.slidingNum).html()}</div>`);
    this.setWrapperHeight()
    this.fixHeights()
  }

  fixHeights(){
    setTimeout(() => {
      this.setWrapperHeight();
    },700);
  }

  getRows(){

    this.rows = this.sliderWrapper.find(".row");
    for (let i = 0; i < this.rows.length; i++) {
      this.rowsHeight.push(this.rows.eq(i).height())
    }
  }

  setPagination () {
    this.slidingButtons = this.$elm.find('.sliding-buttons');
    if (this.rows.length > 1) {
      this.slidingButtons.find('.sliding-count').html(this.rows.length)
      this.slidingButtons.removeClass('hidden')
    }
  }


  bindEvents () {
    this.slidingButtons.on('click', '.next:not(.js_inactive)', (event) => {
      this._processPaging(1);
    });

    this.slidingButtons.on('click', '.prev:not(.js_inactive)', (event) => {
      this._processPaging(-1);
    });

    this.sliderWrapper.on('load', 'img', () => {
       this.setWrapperHeight();
    });

    $(window).on('resize', () => {
      this.baseWidth = this.sliderWrapper.width()
      this.refreshSliderContainerWidth();

      this.rowsHeight = [];
      for (let i = 0; i < this.rows.length; i++) {
        // this.rowsHeight.push(this.rows.eq(i).height())
        this.rowsHeight.push(this.getRealRowHeight(this.rows.eq(i)))
      }

      this.setWrapperHeight(100);
    })
  }

  getRealRowHeight($row) {
    var slideWrappers = this.sliderWrapper.find('> .wysiwyg-insert-content');
    var ret = 0;

    slideWrappers.removeClass("hidden");
    ret = $row.height();
    slideWrappers.addClass("hidden");

    return ret;
  }

  // @param {direction} <ENUM> 1 || -1 (next || prev)
  _processPaging (direction) {
    this.slidingNum += direction
    const prev = this.slidingButtons.find('.prev');
    const next = this.slidingButtons.find('.next');

    if (this.slidingNum == this.rows.length -1 ) {
      prev.removeClass(this.inactiveClass);
      next.addClass(this.inactiveClass);
    } else if (this.slidingNum == 0) {
      prev.addClass(this.inactiveClass);
      next.removeClass(this.inactiveClass);
    } else {
      prev.removeClass(this.inactiveClass);
      next.removeClass(this.inactiveClass);
    }

    this.processSliding(direction);
    this.slidingButtons.find('.sliding-num').html(this.slidingNum + 1);
  }



  // @param {direction} <ENUM> 1 || -1 (next || prev)

  processSliding (direction) {
    this.sliderContainer.stop(true, true);
    this.sliderWrapper.stop(true, true);

    if (this.slidingType == "transition") {
      this.processTransitionSliding()
    } else if (this.slidingType == 'carousel') {
      this.processCarouselSliding(direction)
    } else {
      this.sliderContainer.html(this.rows.eq(this.slidingNum).html())
    }
  }

  processTransitionSliding () {
    this.sliderContainer.fadeOut(500, () => {
      this.sliderContainer.html(this.rows.eq(this.slidingNum).html());
      this.sliderContainer.fadeIn(500);
      this.setWrapperHeight(500)
    })
  }

  refreshSliderContainerWidth() {
    this.sliderContainer.find('.slideItem').css('width', `${this.baseWidth}px`);
  }

  processCarouselSliding (direction) {
    this.sliderWrapper.css('overflow', 'hidden');

    this.sliderContainer.css('width', `${(this.baseWidth * 2)}px`);
    this.refreshSliderContainerWidth();


    if (direction > 0) {
      this.sliderContainer.append(`<div class='slideItem js_newSlideItem'>${this.rows.eq(this.slidingNum).html()}</div>`)
      this.refreshSliderContainerWidth();

      this.setWrapperHeight(500)
      this.sliderContainer.animate({
        marginLeft: - this.baseWidth
      }, 500, "swing", () => this.afterSliding());

    } else {
      this.sliderContainer.prepend(`<div class='slideItem js_newSlideItem'>${this.rows.eq(this.slidingNum).html()}</div>`)
      this.refreshSliderContainerWidth();

      this.sliderContainer.css({marginLeft: - this.baseWidth});

      this.setWrapperHeight(500)
      this.sliderContainer.animate({
        marginLeft: 0
      }, 500, "swing", () => this.afterSliding());
    }
  }

  // @param {time} animation time in ms

  setWrapperHeight (time = 0) {
    this.sliderWrapper.animate({
      height:this.rowsHeight[this.slidingNum]
    }, time);
  }

  afterSliding () {
    this.sliderContainer.find('.js_activeSlideItem').remove();
    this.sliderContainer.css({marginLeft: 0});
    this.sliderContainer.find('.js_newSlideItem').removeClass('js_newSlideItem').addClass('js_activeSlideItem');
  }




















  // bindEvents () {
  //   var t = this;
  //   this.getContext().on("click", ".js_analyticsInteractionTrigger-onClick", function(e){
  //     t._onClick($(e.target).data("analytics-name"));
  //   });
  //
  //   this.getContext().on("change", ".js_analyticsInteractionTrigger-onChange", function(e){
  //     t._onChange($(e.target).data("analytics-name"));
  //   });
  // }
  //
  // _onClick (name) {
  //   window.dataLayer.push({
  //     'event': 'cGtmCartAction',
  //     'caType': 'Interakce',
  //     'caValue': 'Kurzor - '+  name
  //   });
  // }
  //
  // _onChange (name) {
  //   window.dataLayer.push({
  //     'event': 'cGtmCartAction',
  //     'caType': 'Interakce',
  //     'caValue': 'Změna - '+  name
  //   });
  // }


}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web/WysiwygSlider.js